var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCross = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 9 9",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.728.243a.75.75 0 0 0-1.06 0L4.484 3.425 1.303.243a.75.75 0 0 0-1.06 1.06l3.182 3.182L.243 7.667a.75.75 0 1 0 1.06 1.06l3.182-3.181 3.182 3.182a.75.75 0 0 0 1.06-1.06L5.547 4.484l3.182-3.182a.75.75 0 0 0 0-1.06Z"
})));
export default SvgCross;